// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".random-img{padding:0 0 52%;width:100%;position:relative;background-size:cover;background-repeat:no-repeat;background-position:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
